import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';

import Modal from '../../util/modal';

import { Factura_Contado_Transaccion, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey } from '../../request/rfc';

export default class Generar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            transaccion: '',
            serie: '',
            folio: '',
            folioUID: '',
            sucursal: 0,
            showModal: false,
            disabled: false
        };
        AutoBind(this);
    }

    onSubmit(e) {
        // validar el dato tenga algun valor
        e.preventDefault();
        const { transaccion } = this.state;
        if(!transaccion) {
            alert('Debe ingresar un número de transacción.');
        } else {
            this.setState({ disabled: true });
            const { cliente, correo, usocfdi } = this.props.match.params;
            const { transaccion } = this.state;
            const params = { pTransaccion: transaccion, pClienteFiscalId: cliente, pCorreo: correo, pUsoCFDI: usocfdi };
            Factura_Contado_Transaccion(params)
            .then(({data: Response}) => {
                const { Message, Data } = Response;
                if(Message !== '') {
                    alert(Message);
                    this.setState({ disabled: false });
                } else {
                    if(!Data.Exitoso) {
                        alert(Data.Mensaje_Error);
                        this.setState({ disabled: false });
                    } else {
                        this.setState({ serie: Data.Serie, folio: Data.NumeroFactura, sucursal: Data.Suc_Id, 
                                        showModal: true, disabled: false, folioUID: Data.UUID
                        });
                    }
                }
            })
            .catch((err) => { console.log(err); });
        }
        
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onXML() {
        const { sucursal, folio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: sucursal, pFolio: folio })
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message !== '') {
                 alert(Message);
            } else {
                const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                var element = document.createElement('a');
                element.setAttribute('href', pdf);
                element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
        })
        .catch((err) =>{ console.log(err); });
    }

    onPDF() {
        const { sucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: sucursal, pFolio: folioUID })
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message !== '') {
                 alert(Message);
            } else {
                const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                var element = document.createElement('a');
                element.setAttribute('href', pdf);
                element.setAttribute('download', Data.Nombre);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
        })
        .catch((err) =>{ console.log(err); });
    }

    onCloseModal() {
        this.props.history.replace(`${this.state.baseUrl}${Routes.Home}`);
    }

    render() {
        
        const { baseUrl, serie, folio, transaccion, showModal, disabled } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-download';
        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <Link to={`${baseUrl}${Routes.RFC}`} className="btn btn-custom-theme float-right" style={linkStyle} >
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>
                        <form id="form-rfc" onSubmit={this.onSubmit}>
                            <div className="col-12 form-group">
                                <label>Número Transacción:</label>
                                <input type="text" className="form-control" name="transaccion" value={transaccion} readOnly={disabled}
                                        onChange={this.onChange} />
                            </div>
                            <div className="col-12 form-group">
                                <button type="sumbit" className="btn btn-custom-theme float-right" disabled={disabled}>
                                    <i className={cssClassSpin}></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <Modal show={showModal} 
                         serie={serie}
                         folio={folio}
                         onXML={this.onXML}
                         onPDF={this.onPDF}
                         onCloseModal={this.onCloseModal}
                />
            </Fragment>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/transaccion/index.jsx